export const TEMPLATE_CONSTANTS = {
  MAX_FILE_SIZE: 10 * 1024 * 1024,
  TEMPLATE_NAME: 'plantilla-carga-masiva.csv'
};

export const BULK_UPLOAD_TITLE = 'Carga Masiva';
